
import {Routes} from 'constants/index';
import qs from 'qs';

interface BookingProps {
	slug: string
	date: string
	appt?: string
}

export const createBookingLink = ({slug, date, appt}: BookingProps) => {
	let args = '';
	if (appt) {
		args = '?' + qs.stringify({
			'st.appt': appt,
		});
	}
	return `${Routes.scanMe}/${slug}/${date}${args}`;
};
